import { render, staticRenderFns } from "./PaymentLink.vue?vue&type=template&id=523becfb&scoped=true&"
import script from "./PaymentLink.vue?vue&type=script&lang=js&"
export * from "./PaymentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523becfb",
  null
  
)

export default component.exports